// When built, it will be output as rdbleuclair/javascripts/theme.js
import './scripts/rdbleuclair.js'

// When built, it will be output as rdbleuclair/stylesheets/theme.css
import './styles/rdbleuclair.scss';
